<template>
  <div id="app" :class="fontStyle.fontFamily">
    <router-view />
  </div>
</template>
<script>
import i18n from "./locales";
// import Bowser from 'bowser';
export default {
  mounted() {
    this.detectOperatingSystem();
  },
  data() {
    return {
      fontStyle: {
        fontFamily: "Andmyfonts",
      },
      locales: "",
    };
  },
  methods: {
    detectOperatingSystem() {
      const userAgent = navigator.userAgent;
      if (/Android/i.test(userAgent)) {
        // 当前是 Android 系统
        this.fontStyle.fontFamily = "Andmyfonts";
        if (this.locales === "en-us") {
          this.fontStyle.fontFamily = "AndmyfontsUs";
        } else {
          this.fontStyle.fontFamily = "Andmyfonts";
        }
        // 在这里可以设置 Android 系统的字体样式
      } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        // 当前是 iOS 系统
        console.log("当前操作系统是 iOS");
        // 在这里可以设置 iOS 系统的字体样式
        this.fontStyle.fontFamily = "iosmyfonts";
        if (this.locales === "en-us") {
          this.fontStyle.fontFamily = "iosmyfontsUs";
        } else {
          this.fontStyle.fontFamily = "iosmyfonts";
        }
      } else {
        // 其他操作系统
        console.log("当前操作系统不是 Android 也不是 iOS");
      }
    },
  },
  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      // 处理i18n.locale变化的逻辑
      this.locales = newLocale;
      this.detectOperatingSystem();
    },
  },
};
</script>
<style lang="less">
// 安卓
.Andmyfonts {
  font-family: "思源黑体";
}
// 英文
.AndmyfontsUs {
  font-family: "Roboto";
}
// iOS
.iosmyfonts {
  font-family: "苹方";
}
// 英文
.iosmyfontsUs {
  font-family: "San-Francisco";
}
</style>
